import React, { useState, useEffect } from 'react'
import { useUser } from 'util/UserContext'
import { useParams, useNavigate, Navigate } from 'react-router-dom'
import AdminReports from './AdminReports'
import AdminFeedback from './AdminFeedback'
import ScrollableTabsList from 'ui/ScrollableTabsList'

const AdminPortal = () => {
    const { currentUser, awaitingUser } = useUser()
    const { tab } = useParams<{ tab: string }>()
    const navigate = useNavigate()
    const [selectedTab, setSelectedTab] = useState<string>(tab || 'reports')
    const [isAdmin, setIsAdmin] = useState<boolean | null | undefined>(null)

    useEffect(() => {
        if (!awaitingUser) {
            if (currentUser !== null) {
                setIsAdmin(currentUser.is_admin || false)
            }
        }
    }, [currentUser, awaitingUser])

    // Update selectedTab when URL tab parameter changes
    useEffect(() => {
        if (!awaitingUser && isAdmin) {
            if (tab) {
                setSelectedTab(tab)
            } else {
                setSelectedTab('reports')
            }
        }
    }, [awaitingUser, isAdmin, tab])

    const handleTabChange = (newTab: string) => {
        setSelectedTab(newTab)
        navigate(newTab === 'reports' ? '/admin' : `/admin/${newTab}`)
    }

    const tabsData = [
        {
            label: 'Reports',
            route: '/admin/reports',
            value: 'reports',
        },
        {
            label: 'Feedback',
            route: '/admin/feedback',
            value: 'feedback',
        },
    ]

    if (awaitingUser) {
        return <div className="p-4">Loading...</div>
    }

    if (!awaitingUser && (!currentUser || !currentUser.is_admin)) {
        return <Navigate to="/" />
    }

    return (
        <div className="dark:!bg-eoe-dark-bg">
            <div className="w-full mt-4">
                <ScrollableTabsList
                    key="admin-tabs"
                    tabs={tabsData}
                    selectedTab={selectedTab}
                    onTabChange={handleTabChange}
                    pageTitle="Admin Portal"
                />
                
                <div className="mt-4">
                    {selectedTab === 'reports' && (
                        <AdminReports isAdmin={isAdmin || false} />
                    )}
                    {selectedTab === 'feedback' && (
                        <AdminFeedback isAdmin={isAdmin || false} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default AdminPortal
